import { PlatformMetaKeyUtils } from '@shared/utils/platform-meta-key.utils';

/** The translation key naming the Alt key as the planner's keyboard labels it. */
export function altKeyLabelKey(): string {
  return PlatformMetaKeyUtils.isMac()
    ? 'features.plan.edit.pin_drag.keys.option'
    : 'features.plan.edit.pin_drag.keys.alt';
}
